import React, { Component } from "react";
import { Form, Modal } from "antd";
import FormCreate from "../../../../../../components/FormCreate/index";
import styles from "./index.less";

const { FormTitle, FormSelect } = FormCreate;

const normTypeData = [
  {
    value: 1,
    label: "学校发展性评价"
  },
  {
    value: 2,
    label: "人民政府履行教育职责评价"
  },
  {
    value: 3,
    label: "义务教育均衡发展监测"
  }
];
@Form.create()
class EditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.data.name || "",
      type: props.data.type || undefined
    };
  }

  handleOk = () => {
    const { onOk, form, data } = this.props;
    const { id } = data;
    const { getFieldsValue } = form;
    const nameValue = getFieldsValue().name || "";
    const { type } = this.state;
    const { validateFields } = form;
    validateFields(err => {
      if (!err && onOk) {
        onOk({ id, type, name: nameValue });
      }
    });
  };

  handleTypeChange = val => {
    this.setState({
      type: val
    });
  };

  render() {
    const { name, type } = this.state;
    const { title, form, onCancel } = this.props;
    const { getFieldsValue } = form;
    const nameValue = getFieldsValue().name || name || "";
    const typeValue = getFieldsValue().type || type || "";

    const normTypeProps = {
      keyName: "type",
      optionData: normTypeData,
      isRequired: true,
      form,
      label: "模板类型",
      value: type,
      onChange: this.handleTypeChange,
      placeholder: "请选择模板类型"
    };
    const normNameProps = {
      form,
      value: name,
      label: "指标模板名称",
      keyName: "name",
      maxLength: 100,
      suffix: `${(getFieldsValue().name && getFieldsValue().name.length) ||
        0}/100`
    };
    return (
      <Modal
        title={title}
        centered
        visible
        onOk={this.handleOk}
        onCancel={onCancel}
        okButtonProps={{
          disabled:
            !nameValue.trim().length ||
            nameValue.trim().length > 100 ||
            !typeValue
        }}
        wrapClassName={styles.addModal}
      >
        <FormCreate labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          <FormSelect {...normTypeProps} />
          <FormTitle {...normNameProps} />
        </FormCreate>
      </Modal>
    );
  }
}

export default EditModal;
